// extracted by mini-css-extract-plugin
module.exports = {"price_con":"index_price_con__2YtYX","price_title":"index_price_title__3xYrO"};